import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PhoneInput from 'react-phone-number-input';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import InfoIcon from '../../assets/icon-info.svg';
import CustomAlert from '../../components/CustomAlert';
import CustomTooltip from "../../components/CustomTooltip";
import config from '../../config/Constant';
import { postRequest } from '../../helpers/apiHandler';
import { reloadContactList, reloadContactOverview } from '../../store/actions/reduxAction';
import CloseIcon from '../SVG/CloseIcon';
import { GreenIconSVG } from '../SVG/GreenIconSVG';

const ContactAddContact = (props) => {
  const {
    openModalAddContact,
    setOpenModalAddContact,
    allTags,
    contactList
  } = props;

  const dispatch = useDispatch();
  const { access_token } = useSelector((state) => state.auth.user)
  const [stateFormContact, setStateFormContact] = useState('add');
  const [tagOptions, setTagOptions] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedContactList, setSelectedContactList] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [contactListError, setContactListError] = useState('');
  const [contactName, setContactName] = useState('');
  const [contactNameError, setContactNameError] = useState({ error: false, message: '' });
  const [selectedOption, setSelectedOption] = useState('create');


  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  useEffect(() => {
    if (openModalAddContact === true) {
      setTagOptions(allTags);
    }
  }, [openModalAddContact]);

  const handleCloseModel = () => {
    setOpenModalAddContact(false);
    setError('');
  };

  const validatePhoneNumber = () => {
    if (!phoneNumber) {
      setPhoneError('Mobile number is required.')
      return false;
    }
    return true;
  };

  const handleAddContact = () => {
    const trimmedContactName = contactName.trim();

    if (selectedOption === 'create' && !trimmedContactName) {
      setContactListError('');
      setContactNameError({ error: true, message: 'Please provide a New Contact List Name' });
      return;
    }

    if (selectedOption === 'create' && (trimmedContactName.length < 2 || trimmedContactName.length > 30)) {
      setContactListError('');
      setContactNameError({ error: true, message: 'Contact list name must be between 2 and 30 characters long.' });
      return;
    }

    if (selectedOption === 'update' && !selectedContactList) {
      setContactListError('Please select a Contact List.');
      setContactNameError({ error: false, message: '' });
      return;
    }

    setContactListError('');
    setContactNameError({ error: false, message: '' });

    if (!validatePhoneNumber()) {
      return;
    }
    setPhoneError('')

    const tags = selectedTags ? selectedTags.map((tag) => tag.value) : [];

    const data = {
      phone: phoneNumber,
      custom_field: name ? { name: name } : null,
      tags: tags,
    };

    if (selectedOption === 'create') {
      data.lead_list_name = trimmedContactName;
    } else {
      data.lead_list_id = selectedContactList.value;
    }

    postRequest('/v2/contacts-add-single-contact', data, access_token.token, (res) => {
      if (res.success) {
        setPhoneNumber('')
        setName('')
        setSelectedTags([])
        setSelectedContactList('')
        setContactName('');
        // Handle success if needed
        handleCloseModel(true);
        dispatch(reloadContactList());
        dispatch(reloadContactOverview());
        setAlertState({
          message: 'Contact(s) successfully added.',
          show: true,
          variant: 'success',
        });
      } else {
        const message = res.code === 12200
          ? 'Contact List name must be unique'
          : res.message || 'There was an error saving contact.';

        setAlertState({
          message,
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    setContactListError('');
    setContactNameError({ error: false, message: '' });

    if (e.target.value === 'create') {
      setSelectedContactList('');
    } else {
      setContactName('');
    }
  }

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Modal
        show={openModalAddContact}
        animation={true}
        onHide={() => {
          handleCloseModel(false);
          setStateFormContact('add');
        }}
        className="modal-form-contact"
        centered
      >
        <Modal.Body>
          <CloseIcon handleModalClose={handleCloseModel} />
          <GreenIconSVG />
          <Modal.Title as="h4" style={{ margin: '8px 0 16px' }}>
            {stateFormContact === 'add' ? 'Add' : 'Edit'} Contact
          </Modal.Title>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form>
            <Form.Group>
              <Form.Label>Mobile Number*</Form.Label>
              <div className="phone-number-wrapper">
                <PhoneInput
                  international
                  placeholder="Enter mobile number"
                  defaultCountry="MY"
                  value={phoneNumber}
                  onChange={setPhoneNumber}
                />
              </div>
              {phoneError && <span className="red-required">{phoneError}</span>}
            </Form.Group>
            <Form.Group>
              <div className='radio-container'>
                <input id='create' type='radio' value='create' checked={selectedOption === 'create'} onChange={handleOptionChange} className='mr-2' />
                <label htmlFor="create" className='radio-label'>
                  Create New Contact List <CustomTooltip id='create-tooltip' placement='right' message='Use Contact List to organize your contacts into groups. Ensure the Contact List Name is unique.' />
                </label>
              </div>
              {selectedOption === 'create' ? <>
                <Form.Control
                  maxLength={30}
                  placeholder="Enter New Contact List Name"
                  value={contactName}
                  onChange={(e) => {
                    setSelectedContactList('');
                    setContactNameError({ error: false, message: '' });
                    setContactName(e.target.value);
                  }}
                  isInvalid={contactNameError.error}
                />
                <Form.Control.Feedback type="invalid">{contactNameError.message}</Form.Control.Feedback>
              </> : <></>}
            </Form.Group>
            <Form.Group>
              <div className='radio-container'>
                <input id='update' type='radio' value='update' checked={selectedOption === 'update'} onChange={handleOptionChange} className='mr-2' />
                <label htmlFor="update" className='radio-label'>
                  Add into existing Contact List <CustomTooltip id='add-existing-tooltip' placement='right' message='Select one contact list from the dropdown below.' />
                </label>
              </div>
              {selectedOption === 'update' ? <>
                <Select
                  options={contactList.map((item) => ({ value: item.id, label: item.name }))}
                  placeholder="Select Contact List"
                  onChange={setSelectedContactList}
                  value={selectedContactList}
                />
                {contactListError && <span className="red-required">{contactListError}</span>}
              </> : <></>}
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Name
                <span style={{ color: 'grey', marginLeft: '5px' }}>(optional)</span>
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="tooltip-name">
                      E.g. John
                    </Tooltip>
                  }
                >
                  <span className="ml-2"><img src={InfoIcon} style={{ width: '14px' }}></img></span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                value={name}
                onChange={(e) => {
                  const { value } = e.target;
                  if (value.length <= 30) {
                    setName(value);
                  }
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Tags <span style={{ color: 'grey', marginLeft: '5px' }}>(optional)</span>
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="tooltip-name">
                      Assign tags: Select from the dropdown, or type and press Enter to create a new tag.
                    </Tooltip>
                  }
                >
                  <span className="ml-2"><img src={InfoIcon} style={{ width: '14px' }}></img></span>
                </OverlayTrigger>
              </Form.Label>
              <CreatableSelect
                isMulti
                options={tagOptions.map((tag) => ({ value: tag, label: tag }))}
                value={selectedTags}
                onChange={setSelectedTags}
                placeholder={tagOptions && tagOptions.length > 0 ? "Select..." : "No created tags"}
              />
            </Form.Group>

            <Form.Group>
              <Button variant="primary" style={{ minWidth: 160 }} onClick={handleAddContact}>
                Save
              </Button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ContactAddContact
